export enum API_BASE_URLS_PROD {
  MERCHANDISING_SITE_EXPERIENCE = 'https://merchandising-site-experience.prod.merch.vpsvc.com/',
  ACCOUNT_SERVICE = 'https://account-service.orders.vpsvc.com',
  DIWY = 'https://wix-diwy.digital.vpsvc.com',
  PAID = 'https://subscription-data-api.orders.vpsvc.com',
  PARTNER_INTEGRATION_SERVICE = 'https://partners.vpsvc.com',
  SUBSCRIPTION_SERVICE = 'https://subscription-service.orders.vpsvc.com',
  URL_SERVICE = 'https://url.prod.merch.vpsvc.com',
  WRANGLER = 'https://wrangler.prod.merch.vpsvc.com',
  PARTNER_COMPLEMENTARY_PRODUCTS_SERVICE = 'https://partnerproducts.digital.vpsvc.com',
}

type PartnerNavigationUrlMapType = { [key: string]: string };
export const API_PARTNER_NAVIGATION_URLS_PROD: PartnerNavigationUrlMapType = {
  'en-US': 'https://partners.vistaprint.com',
  'es-US': 'https://partners.vistaprint.com',
  'en-CA': 'https://partners.vistaprint.ca',
  'fr-CA': 'https://partners.vistaprint.ca',
  'en-IE': 'https://partners.vistaprint.ie',
  'pt-PT': 'https://partners.vistaprint.pt',
  'en-IN': 'https://partners.vistaprint.in',
  'es-ES': 'https://partners.vistaprint.es',
  'nl-BE': 'https://partners.vistaprint.be',
  'fr-BE': 'https://partners.vistaprint.be',
  'it-IT': 'https://partners.vistaprint.it',
  'nl-NL': 'https://partners.vistaprint.nl',
  'nb-NO': 'https://partners.vistaprint.no',
  'fi-FI': 'https://partners.vistaprint.fi',
  'sv-SE': 'https://partners.vistaprint.se',
  'en-SG': 'https://partners.vistaprint.sg',
  'da-DK': 'https://partners.vistaprint.dk',
  'en-NZ': 'https://partners.vistaprint.co.nz',
  'en-AU': 'https://partners.vistaprint.com.au',
  'en-GB': 'https://partners.vistaprint.co.uk',
  'de-DE': 'https://partners.vistaprint.de',
  'de-CH': 'https://partners.vistaprint.ch',
  'fr-CH': 'https://partners.vistaprint.ch',
  'it-CH': 'https://partners.vistaprint.ch',
  'de-AT': 'https://partners.vistaprint.at',
  'fr-FR': 'https://partners.vistaprint.fr',
};

export enum API_BASE_URLS_QA {
  ACCOUNT_SERVICE = 'https://account-service-staging.orders.vpsvc.com',
  DIWY = 'https://qa.wix-diwy.digital.vpsvc.com',
  PAID = 'https://subscription-data-api-staging.orders.vpsvc.com',
  PARTNER_INTEGRATION_SERVICE = 'https://qa.partner-integration.digital.vpsvc.com',
  PARTNER_NAVIGATION_SERVICE = 'https://qa.partner-navigation.digital.vpsvc.com',
  SUBSCRIPTION_SERVICE = 'https://subscription-service-staging.orders.vpsvc.com',
  PARTNER_COMPLEMENTARY_PRODUCTS_SERVICE = 'https://qa.partnerproducts.digital.vpsvc.com',
}
